export default __webpack_public_path__ + "static/media/carousel_left_arrow.a159e45c.png";